// Angular
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
// Service
import { ViewsService } from '../../../../../../../../services/views.service';
import { CVfUtilsService } from '../../../../../../../services/cvf-utils.service';
// Model
import { FormControl, FormGroup } from '@angular/forms';
import { SCHEMA_TYPE } from '../../../../../../../../models/enums.model';
import { SmartTagAssetModel } from '../../../model/smartTagAsset';
import { SmartTagTemplateForm } from '../../../model/smart-tag-template-form.model';

@Component({
	selector: 'cv-schema-render-smart-tag-assets-template',
	templateUrl: './smart-tag-assets-template.component.html',
})
export class SmartTagAssetsTemplateComponent extends SmartTagTemplateForm implements OnInit {

	@Input() smartTagModel: SmartTagAssetModel = null;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

	public orderSchema = '';

	get schemaShouldShowComplexForm(): boolean {
		let response = false;
		const schemasShouldShow = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString()
		];

		response = schemasShouldShow.indexOf(this.orderSchema) > -1

		return response
	}

	constructor(
		private viewsService: ViewsService,
		protected cvfUtils: CVfUtilsService
	) {
		super(cvfUtils);
	}

	ngOnInit() {

		this.orderSchema = this.viewsService.order.schema;
		// Basic Form
		this.innerForm = new FormGroup({
			description: new FormControl(this.smartTagModel.description)
		});

		switch (this.orderSchema) {
			case SCHEMA_TYPE.CVDS_40:
			case SCHEMA_TYPE.INSPECTIONLESS_1:
				this.innerForm.addControl('brand', new FormControl(this.smartTagModel.brand));
				this.innerForm.addControl('serialNumber', new FormControl(this.smartTagModel.serialNumber));
				this.innerForm.addControl('modelNumber', new FormControl(this.smartTagModel.modelNumber));
				this.innerForm.addControl('age', new FormControl(this.smartTagModel.age));
				break;
		}

		// Everytime the Form Change
		this.innerForm.valueChanges.subscribe(() => this.onValuesChange());
	}

	/**
	 * Emit values and status of this Form, for inner components and library too
	 * @private
	 */
	public onValuesChange(): void {
		const formValue = this.processOutputObject(this.smartTagModel);
		this.valueChange.next({ valid: this.innerForm.valid, value: formValue });
	}

}
